import { Button } from "react-bootstrap";

const CursoSelector = ({ cursos, handleCursoClick }) => {
  // 1. Group cursos by comuna + nombre
  const grouped = cursos.reduce((acc, curso) => {
    const key = `${curso.comuna}-${curso.nombre}`;

    if (!acc[key]) acc[key] = [];
    acc[key].push(curso);

    return acc;
  }, {});

  // 2. Flatten with index per group
  const cursosWithIndex = Object.values(grouped).flatMap((group) =>
    group.map((curso, index) => ({
      ...curso,
      displayIndex: group.length > 1 ? group.length - index : null
    }))
  );

  return (
    <div>
      <h6>Selecciona Curso</h6>

      {cursosWithIndex.map((curso) => (
        <Button
          key={curso.id}
          onClick={() => handleCursoClick(curso)}
          className="asistencia-curso-item"
        >
          {curso.comuna} - {curso.nombre}
          {curso.displayIndex ? ` (${curso.displayIndex})` : ""}
        </Button>
      ))}
    </div>
  );
};

export default CursoSelector;